import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  silentTranslationWarn: process.env.NODE_ENV === 'production' ? true : false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    "en": '',
  },
});

function setI18nLanguage (lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync (lang) {

  i18n.setLocaleMessage(lang, languages[lang]);
  return setI18nLanguage(lang);
}

const languages = {
  'en': {
    "title":                                      "Title",
    "category":                                   "Category",
    "format":                                     "Format",
    "categoryPlaceholder":                        "Showing all categories",
    "filterPlaceholder":                          "Begin typing to filter by title or category",
    "news":                                       "Visit the News & Events section to view press releases and posts.",
    "All categories":                             "All categories",
    "All employers & employees":                  "All employers & employees",
    "Community & family gatherings":              "Community & family gatherings",
    "Contact tracing":                            "Contact tracing",
    "Education & childcare":                      "Education & childcare",
    "Entertainment & culture":                    "Entertainment & culture",
    "Food, restaurants & hospitality":            "Food, restaurants & hospitality",
    "Gyms, recreation & sports":                  "Gyms, recreation & sports",
    "Home health care & outpatient services":     "Home health care & outpatient services",
    "Manufacturing, construction & real estate":  "Manufacturing, construction & real estate",
    "Offices":                                    "Offices",
    "Personal health & safety":                   "Personal health & safety",
    "Retail & personal services":                 "Retail & personal services",
    "Retail & professional services":             "Retail & professional services",
    "Senior care & recreation":                   "Senior care & recreation",
    "Testing":                                    "Testing",
    "Transportation":                             "Transportation",
    "Vaccine":                                    "Vaccine",
    "Application (PDF)":                          "Application (PDF)",
    "Application":                                "Application",
    "Document collection":                        "Document collection",
    "Guidance":                                   "Guidance",
    "Guidance document (PDF)":                    "Guidance document (PDF)",
    "Illustrated guidance (PDF)":                 "Illustrated guidance (PDF)",
    "Interactive map":                            "Interactive map",
    "Sector-specific safety protocols":           "Sector-specific safety protocols",
    "Service page":                               "Service page",
    "Website":                                    "Website",
  },
  'es': {
    "title":                                      "Título",
    "category":                                   "Categoría",
    "format":                                     "Formato",
    "categoryPlaceholder":                        "Mostrando todas las categorías",
    "filterPlaceholder":                          "Comience a escribir para filtrar por título o categoría",
    "news":                                       "Visite la sección Noticias y Eventos para ver publicaciones",
    "All categories":                             "Todas las categorías",
    "All employers & employees":                  "Todos los empleadores y empleados",
    "Community & family gatherings":              "Reuniones comunitarias y familiares",
    "Contact tracing":                            "Rastreo de contactos",
    "Education & childcare":                      "Educación y cuidado de niños",
    "Entertainment & culture":                    "Entretenimiento y cultura",
    "Food, restaurants & hospitality":            "Alimentos, restaurantes y hospitalidad",
    "Gyms, recreation & sports":                  "Gimnasios, recreación y deportes",
    "Home health care & outpatient services":     "Servicios de atención de la salud y pacientes ambulatorios",
    "Manufacturing, construction & real estate":  "Fabricación, construcción y bienes raíces",
    "Offices":                                    "Oficinas",
    "Personal health & safety":                   "Salud y seguridad personal",
    "Retail & personal services":                 "Servicios personales y de venta minorista",
    "Retail & professional services":             "Servicios profesionales y de venta minorista",
    "Senior care & recreation":                   "Atención y recreación para adultos mayores",
    "Testing":                                    "Pruebas",
    "Transportation":                             "Transporte",
    "Vaccine":                                    "Vacunas",
    "Application (PDF)":                          "Solicitud (PDF)",
    "Application":                                "Solicitud",
    "Document collection":                        "Recolección de documentos",
    "Guidance":                                   "Guía",
    "Guidance document (PDF)":                    "Documento guía (PDF)",
    "Illustrated guidance (PDF)":                 "Guías ilustradas (PDF)",
    "Interactive map":                            "Mapa interactivo",
    "Sector-specific safety protocols":           "Protocolos específicos de seguridad",
    "Service page":                               "Página de servicio",
    "Website":                                    "Sitio web",
  },
  'fr': {
    "title":                                      "Titre",
    "category":                                   "Catégorie",
    "format":                                     "Format",
    "categoryPlaceholder":                        "Montrer toutes catégories",
    "filterPlaceholder":                          "Commencer à saisir pour filtrer par titre et catégorie",
    "news":                                       "Rendez-vous sur la section Actualités et événements pour afficher les nouvelles publications.",
    "All categories":                             "Toutes catégories",
    "All employers & employees":                  "Tous employeurs et employés",
    "Community & family gatherings":              "Rassemblements communautaires et familiaux",
    "Contact tracing":                            "Traçage des contacts",
    "Education & childcare":                      "Éducation et garde d'enfants",
    "Entertainment & culture":                    "Divertissements et culture",
    "Food, restaurants & hospitality":            "Alimentation, restaurants et hôtellerie",
    "Gyms, recreation & sports":                  "Centres de remise en forme, loisirs et sports",
    "Home health care & outpatient services":     "Services de soins ambulatoires et à domicile",
    "Manufacturing, construction & real estate":  "Fabrication, bâtiment et immobilier",
    "Offices":                                    "Bureaux",
    "Personal health & safety":                   "Santé et sécurité personnelles",
    "Retail & personal services":                 "Ventes au détail et services personnels",
    "Senior care & recreation":                   "Soins et loisirs pour seniors",
    "Testing":                                    "Dépistage",
    "Transportation":                             "Transports",
    "Vaccine":                                    "Vaccin",
    "Application (PDF)":                          "Formulaire de demande (PDF)",
    "Document collection":                        "Collecte de documents",
    "Guidance":                                   "Orientation",
    "Illustrated guidance (PDF)":                 "Orientation illustrée (PDF)",
    "Interactive map":                            "Carte interactive",
    "Sector-specific safety protocols":           "Protocoles de sécurité spécifiques aux secteurs",
    "Service page":                               "Page des services",
    "Website":                                    "Site Web",
  },
  'ht': {
    "title":                                      "Tit",
    "category":                                   "Kategori",
    "format":                                     "Fòma",
    "categoryPlaceholder":                        "Montre tout kategori",
    "filterPlaceholder":                          "Kòmanse tape pou triye pa tit oswa kategori",
    "news":                                       "Vizite seksyon nouvèl ak evènman yo pou wè nòt pou laprès ak pòs yo.",
  },
  'id': {
    "title":                                      "Judul",
    "category":                                   "Kategori",
    "format":                                     "Format",
    "categoryPlaceholder":                        "Menampilkan semua kategori",
    "filterPlaceholder":                          "Mulailah mengetik untuk memfilter berdasarkan judul atau kategori",
    "news":                                       "Kunjungi bagian Berita & Acara untuk melihat rilis pers dan postingan.",
  },
  'km': {
    "title":                                      "តួនាទី",
    "category":                                   "ប្រភេទ",
    "format":                                     "ទ្រង់ទ្រាយ",
    "categoryPlaceholder":                        "បង្ហាញគ្រប់ប្រភេទ",
    "filterPlaceholder":                          "ចាប់ផ្តើមវាយបញ្ចូលដើម្បីចម្រោះឯកសារតាមចំណងជើង ឬប្រភេទ",
    "news":                                       "ទស្សនាផ្នែកព័ត៌មាននិងព្រឹត្តិការណ៍ដើម្បីមើលសេចក្តីប្រកាសព័ត៌មាន។",
  },
  'ko': {
    "title":                                      "제목",
    "category":                                   "범주",
    "format":                                     "형식",
    "categoryPlaceholder":                        "모든 범주 보기",
    "filterPlaceholder":                          "제목이나 범주로 검색하려면 입력을 시작하세요",
    "news":                                       "포스트를 보려면 뉴스 및 이벤트 섹션을 방문하세요.",
    "All categories":                             "모든 범주",
    "All employers & employees":                  "모든 고용주 및 직원",
    "Community & family gatherings":              "커뮤니티 및 가족 모임",
    "Contact tracing":                            "연락 추적",
    "Education & childcare":                      "교육 및 보육",
    "Entertainment & culture":                    "오락 및 문화",
    "Food, restaurants & hospitality":            "식음료, 요식 및 접객",
    "Gyms, recreation & sports":                  "짐, 레크리에이션 및 스포츠",
    "Home health care & outpatient services":     "가정 건강 관리 및 외래환자 서비스",
    "Manufacturing, construction & real estate":  "제조, 건축 및 부동산",
    "Offices":                                    "사무실",
    "Personal health & safety":                   "개인 건강 및 안전",
    "Retail & personal services":                 "소매 및 개인 서비스",
    "Senior care & recreation":                   "노인 관리 및 레크리에이션",
    "Testing":                                    "검사",
    "Transportation":                             "교통",
    "Vaccine":                                    "백신",
    "Application (PDF)":                          "신청(PDF)",
    "Document collection":                        "서류 취합",
    "Guidance":                                   "지침",
    "Illustrated guidance (PDF)":                 "그림 지침(PDF)",
    "Interactive map":                            "대화형 지도",
    "Sector-specific safety protocols":           "분야별 안전 프로토콜",
    "Service page":                               "서비스 페이지",
    "Website":                                    "웹사이트",
  },
  'ru': {
    "title":                                      "Название",
    "category":                                   "Категория",
    "format":                                     "Формат",
    "categoryPlaceholder":                        "Показаны все категории",
    "filterPlaceholder":                          "Начните ввод текста для фильтрации по названию или категории",
    "news":                                       "Для просмотра публикаций перейдите в раздел «Новости и события».",
    "All categories":                             "Все категории",
    "All employers & employees":                  "Все работодатели и сотрудники",
    "Community & family gatherings":              "Общественные и семейные собрания",
    "Contact tracing":                            "Отслеживание контактов",
    "Education & childcare":                      "Образование и детские учреждения",
    "Entertainment & culture":                    "Развлечения и культура",
    "Food, restaurants & hospitality":            "Питание, рестораны и гостиницы",
    "Gyms, recreation & sports":                  "Спортивные залы, развлекательные мероприятия и спорт",
    "Home health care & outpatient services":     "Уход на дому и амбулаторное лечение",
    "Manufacturing, construction & real estate":  "Производство, строительство и недвижимость",
    "Offices":                                    "Офисы",
    "Personal health & safety":                   "Охрана здоровья и меры безопасности",
    "Retail & personal services":                 "Розничная торговля и бытовые услуги",
    "Senior care & recreation":                   "Уход за пожилыми людьми и оздоровительные центры",
    "Testing":                                    "Тестирование",
    "Transportation":                             "Транспорт",
    "Vaccine":                                    "Вакцина",
    "Application (PDF)":                          "Заявление (PDF)",
    "Document collection":                        "Набор документов",
    "Guidance":                                   "Рекомендации",
    "Illustrated guidance (PDF)":                 "Иллюстрированные рекомендации (PDF)",
    "Interactive map":                            "Интерактивная карта",
    "Sector-specific safety protocols":           "Протоколы безопасности для конкретных отраслей",
    "Service page":                               "Страница услуг",
    "Website":                                    "Веб-сайт",
  },
  'sw': {
    "title":                                      "Kichwa",
    "category":                                   "Kategoria",
    "format":                                     "Umbizo",
    "categoryPlaceholder":                        "Inaonyesha kategoria zote",
    "filterPlaceholder":                          "Anza kucharaza ili kuchuja kwa kichwa au kategoria",
    "news":                                       "Tembelea sehemu ya Habari na Matukio kuona matangazo na machapisho.",
  },
  'vt': {
    "title":                                      "Tiêu_đề",
    "category":                                   "Hạng_mục",
    "format":                                     "Định_dạng",
    "categoryPlaceholder":                        "Hiển thị tất cả các hạng mục",
    "filterPlaceholder":                          "Bắt đầu nhập để lọc theo tiêu đề hoặc hạng mục",
    "news":                                       "Truy cập phần Tin Tức & Sự Kiện để xem các bài đăng.",
    "All categories":                             "Tất cả các hạng mục",
    "All employers & employees":                  "Tất cả chủ lao động & nhân viên",
    "Community & family gatherings":              "Tụ họp cộng đồng & gia đình",
    "Contact tracing":                            "Theo dấu người tiếp xúc",
    "Education & childcare":                      "Giáo dục & chăm sóc trẻ",
    "Entertainment & culture":                    "Giải trí & văn hóa",
    "Food, restaurants & hospitality":            "Thực phẩm, nhà hàng & khách sạn",
    "Gyms, recreation & sports":                  "Phòng tập thể dục, giải trí & thể thao",
    "Home health care & outpatient services":     "Chăm sóc sức khỏe tại nhà & dịch vụ ngoại trú",
    "Manufacturing, construction & real estate":  "Sản xuất, xây dựng & bất động sản",
    "Offices":                                    "Văn phòng",
    "Personal health & safety":                   "Sức khỏe & an toàn cá nhân",
    "Retail & personal services":                 "Bán lẻ & các dịch vụ cá nhân",
    "Senior care & recreation":                   "Chăm sóc người cao tuổi & hoạt động giải trí",
    "Testing":                                    "Xét nghiệm",
    "Transportation":                             "Giao thông vận tải",
    "Vaccine":                                    "Vắc-xin",
    "Application (PDF)":                          "Đơn đăng ký (PDF)",
    "Document collection":                        "Thu thập tài liệu",
    "Guidance":                                   "Hướng dẫn",
    "Illustrated guidance (PDF)":                 "Hướng dẫn được minh họa (PDF)",
    "Interactive map":                            "Bản đồ tương tác",
    "Sector-specific safety protocols":           "Quy chuẩn về an toàn theo lĩnh vực cụ thể",
    "Service page":                               "Trang dịch vụ",
    "Website":                                    "Trang web",
  },
  'zh': {
    "title":                                      "标题",
    "category":                                   "类别",
    "format":                                     "格式",
    "categoryPlaceholder":                        "显示所有类别",
    "filterPlaceholder":                          "开始输入以便按标题或类别筛选",
    "news":                                       "浏览“新闻和事件”以查看发布的内容。",
    "All categories":                             "所有类别",
    "All employers & employees":                  "所有雇主和员工",
    "Community & family gatherings":              "社区和家庭聚会",
    "Contact tracing":                            "接触者追踪",
    "Education & childcare":                      "教育和儿童托管",
    "Entertainment & culture":                    "娱乐和文化",
    "Food, restaurants & hospitality":            "食品、餐馆和酒店",
    "Gyms, recreation & sports":                  "健身、休闲和体育",
    "Home health care & outpatient services":     "家庭保健和门诊服务",
    "Manufacturing, construction & real estate":  "制造、建筑和房地产",
    "Offices":                                    "办公室",
    "Personal health & safety":                   "个人健康和安全",
    "Retail & personal services":                 "零售和个人服务",
    "Senior care & recreation":                   "老年人护理和休闲",
    "Testing":                                    "测试",
    "Transportation":                             "交通",
    "Vaccine":                                    "疫苗",
    "Application (PDF)":                          "申请 (PDF)",
    "Document collection":                        "文件收集",
    "Guidance":                                   "指南",
    "Illustrated guidance (PDF)":                 "图解指南 (PDF)",
    "Interactive map":                            "互动地图",
    "Sector-specific safety protocols":           "特定领域安全协议",
    "Service page":                               "服务页面",
    "Website":                                    "网站",
  },
};